import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';

const AutoCompleteSearch = ({
  handleChange,
  value,
  multiple,
  data,
  handleChangeAuto,
  id,
  label,
  placeHolder,
  name,
  ...rest
}) => {
  return (
    <Autocomplete
      noOptionsText="موردی یافت نشد"
      value={value}
      multiple={multiple}
      id={id}
      options={data || []}
      getOptionLabel={(option) =>
        option?.code
          ? `${option?.code} ${option?.name} `
          : option?.name_fa ||
            option?.name ||
            option?.tag ||
            option?.title ||
            ''
      }
      getOptionSelected={(option, value) => option?.name === value?.name}
      onChange={handleChangeAuto}
      {...rest}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label={label}
          placeholder={placeHolder}
          name={name}
          onChange={handleChange}
          // value={defaultValue}
        />
      )}
    />
  );
};

export default AutoCompleteSearch;
